import { render, staticRenderFns } from "./unauthorized.vue?vue&type=template&id=25689bf8&scoped=true&"
import script from "./unauthorized.vue?vue&type=script&lang=js&"
export * from "./unauthorized.vue?vue&type=script&lang=js&"
import style0 from "./unauthorized.vue?vue&type=style&index=0&id=25689bf8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25689bf8",
  null
  
)

export default component.exports